import { app } from '@/main'

export const APPLICABILITY_OPTIONS = {
  solution: app.$t('notifications.filters.manage:field.option.solution'),
  learning_path: app.$t('notifications.filters.manage:field.option.track'),
  program: app.$t('notifications.filters.manage:field.option.program')
}
